import { render, staticRenderFns } from "./page-row.vue?vue&type=template&id=1c39bdf3"
import script from "./page-row.vue?vue&type=script&lang=js"
export * from "./page-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports